import { HttpClient } from "@angular/common/http";
import { LoginUser } from "../model/loginuser.model";
import { CommonService } from '../../common/services/common.service';
import { environment } from '../../../../environments/environment';
import { Utility } from '../../common/services/utility.service';

export function appInitializer(http: HttpClient, commonService: CommonService) {
  return async () => {
    // it can be as per msal
    // try {
    //   var bearerToken = commonService.bearerToken;
    //   if (Utility.IsNotNullOrEmpty(bearerToken)) {
    //     const user = await commonService.http.post<LoginUser>("UserDetails", {}).toPromise();
    //     commonService.setcurrentUserToken(user.Token);
    //     commonService.setcurrentUser(user);
    //   }
    //   return true;
    // }
    // catch (e) {
    // }
  };
}
